document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-lyd-page-menu]').forEach((toggle) => {
    const nav = document.querySelector('[data-lyd-page-nav]');
    if (!nav) return;
    toggle.addEventListener('click', () => {
      const isOpen = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(isOpen));
    });
  });

  document.querySelectorAll('[data-lyd-filter-group]').forEach((group) => {
    const targetSelector = group.dataset.target;
    const grid = targetSelector ? document.querySelector(targetSelector) : null;
    if (!grid) return;
    group.querySelectorAll('[data-filter]').forEach((button) => {
      button.addEventListener('click', () => {
        const selected = button.dataset.filter;
        group.querySelectorAll('[data-filter]').forEach((item) => item.classList.toggle('is-active', item === button));
        grid.querySelectorAll('[data-category]').forEach((card) => {
          card.hidden = selected !== 'all' && card.dataset.category !== selected;
        });
      });
    });
  });

  const dialog = document.querySelector('[data-lyd-video-dialog]');
  const media = dialog?.querySelector('[data-lyd-video-media]');
  const closeButton = dialog?.querySelector('[data-lyd-video-close]');
  if (!dialog || !media) return;

  const closeVideo = () => {
    media.replaceChildren();
    if (dialog.open) dialog.close();
  };

  document.querySelectorAll('[data-lyd-video]').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const provider = trigger.dataset.provider;
      const source = trigger.dataset.source;
      if (!provider || !source) return;
      let element;
      if (provider === 'youtube') {
        element = document.createElement('iframe');
        element.src = `https://www.youtube.com/embed/${source}?autoplay=1&rel=0`;
        element.allow = 'autoplay; encrypted-media; picture-in-picture';
        element.allowFullscreen = true;
        element.title = trigger.getAttribute('aria-label') || 'Video';
      } else if (provider === 'vimeo') {
        element = document.createElement('iframe');
        element.src = `https://player.vimeo.com/video/${source}?autoplay=1`;
        element.allow = 'autoplay; fullscreen; picture-in-picture';
        element.allowFullscreen = true;
        element.title = trigger.getAttribute('aria-label') || 'Video';
      } else {
        element = document.createElement('video');
        element.src = source;
        element.controls = true;
        element.autoplay = true;
        element.playsInline = true;
      }
      media.replaceChildren(element);
      dialog.showModal();
    });
  });

  closeButton?.addEventListener('click', closeVideo);
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) closeVideo();
  });
  dialog.addEventListener('close', () => media.replaceChildren());
});
